// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: fight/model/enums/ProMmaWeightClassPt.proto

/* eslint-disable */

export const protobufPackage = "io.teamsillim.fightbracket.idl.fight.model";

/**
 * 프로 MMA 체급 (KMMAF · ALLFC, UFC 체급 기준)
 *
 * 부 · 성별 구분 없이 프로 경기에 공통으로 적용한다.
 */
export enum ProMmaWeightClassPayload {
  PRO_MMA_WEIGHT_CLASS_UNKNOWN = 0,
  /** PRO_MMA_STRAW - 스트로급 STRAWWEIGHT (-52.2kg) */
  PRO_MMA_STRAW = 1,
  /** PRO_MMA_FLY - 플라이급 FLYWEIGHT (-56.7kg) */
  PRO_MMA_FLY = 2,
  /** PRO_MMA_BANTAM - 밴텀급 BANTAMWEIGHT (-61.2kg) */
  PRO_MMA_BANTAM = 3,
  /** PRO_MMA_FEATHER - 페더급 FEATHERWEIGHT (-65.8kg) */
  PRO_MMA_FEATHER = 4,
  /** PRO_MMA_LIGHT - 라이트급 LIGHTWEIGHT (-70.3kg) */
  PRO_MMA_LIGHT = 5,
  /** PRO_MMA_WELTER - 웰터급 WELTERWEIGHT (-77.1kg) */
  PRO_MMA_WELTER = 6,
  /** PRO_MMA_MIDDLE - 미들급 MIDDLEWEIGHT (-83.9kg) */
  PRO_MMA_MIDDLE = 7,
  /** PRO_MMA_LIGHT_HEAVY - 라이트헤비급 LIGHT HEAVYWEIGHT (-93.0kg) */
  PRO_MMA_LIGHT_HEAVY = 8,
  /** PRO_MMA_HEAVY - 헤비급 HEAVYWEIGHT (-120.2kg) */
  PRO_MMA_HEAVY = 9,
  UNRECOGNIZED = -1,
}

export function proMmaWeightClassPayloadFromJSON(object: any): ProMmaWeightClassPayload {
  switch (object) {
    case 0:
    case "PRO_MMA_WEIGHT_CLASS_UNKNOWN":
      return ProMmaWeightClassPayload.PRO_MMA_WEIGHT_CLASS_UNKNOWN;
    case 1:
    case "PRO_MMA_STRAW":
      return ProMmaWeightClassPayload.PRO_MMA_STRAW;
    case 2:
    case "PRO_MMA_FLY":
      return ProMmaWeightClassPayload.PRO_MMA_FLY;
    case 3:
    case "PRO_MMA_BANTAM":
      return ProMmaWeightClassPayload.PRO_MMA_BANTAM;
    case 4:
    case "PRO_MMA_FEATHER":
      return ProMmaWeightClassPayload.PRO_MMA_FEATHER;
    case 5:
    case "PRO_MMA_LIGHT":
      return ProMmaWeightClassPayload.PRO_MMA_LIGHT;
    case 6:
    case "PRO_MMA_WELTER":
      return ProMmaWeightClassPayload.PRO_MMA_WELTER;
    case 7:
    case "PRO_MMA_MIDDLE":
      return ProMmaWeightClassPayload.PRO_MMA_MIDDLE;
    case 8:
    case "PRO_MMA_LIGHT_HEAVY":
      return ProMmaWeightClassPayload.PRO_MMA_LIGHT_HEAVY;
    case 9:
    case "PRO_MMA_HEAVY":
      return ProMmaWeightClassPayload.PRO_MMA_HEAVY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ProMmaWeightClassPayload.UNRECOGNIZED;
  }
}

export function proMmaWeightClassPayloadToJSON(object: ProMmaWeightClassPayload): string {
  switch (object) {
    case ProMmaWeightClassPayload.PRO_MMA_WEIGHT_CLASS_UNKNOWN:
      return "PRO_MMA_WEIGHT_CLASS_UNKNOWN";
    case ProMmaWeightClassPayload.PRO_MMA_STRAW:
      return "PRO_MMA_STRAW";
    case ProMmaWeightClassPayload.PRO_MMA_FLY:
      return "PRO_MMA_FLY";
    case ProMmaWeightClassPayload.PRO_MMA_BANTAM:
      return "PRO_MMA_BANTAM";
    case ProMmaWeightClassPayload.PRO_MMA_FEATHER:
      return "PRO_MMA_FEATHER";
    case ProMmaWeightClassPayload.PRO_MMA_LIGHT:
      return "PRO_MMA_LIGHT";
    case ProMmaWeightClassPayload.PRO_MMA_WELTER:
      return "PRO_MMA_WELTER";
    case ProMmaWeightClassPayload.PRO_MMA_MIDDLE:
      return "PRO_MMA_MIDDLE";
    case ProMmaWeightClassPayload.PRO_MMA_LIGHT_HEAVY:
      return "PRO_MMA_LIGHT_HEAVY";
    case ProMmaWeightClassPayload.PRO_MMA_HEAVY:
      return "PRO_MMA_HEAVY";
    case ProMmaWeightClassPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
